import { render } from "./CTitle.vue?vue&type=template&id=37d776f8&scoped=true"
import script from "./CTitle.vue?vue&type=script&lang=js"
export * from "./CTitle.vue?vue&type=script&lang=js"

import "./CTitle.vue?vue&type=style&index=0&id=37d776f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d776f8"]])

export default __exports__